import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  imports: [AnimateOnScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestimonialsComponent {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().testimonials);

  testimonials = computed(() => this.t().items);

  private readonly bgImageUrl = 'assets/images/testimonials-bg.jpg';

  bgStyle = computed(() => 
    `linear-gradient(rgba(17, 24, 39, 0.9), rgba(17, 24, 39, 0.9)), url('${this.bgImageUrl}')`
  );
}